
// FirebaseConfig.js (Código de React)
import { initializeApp } from "firebase/app";
import {
    getMessaging,
    getToken,
    onMessage,
    isSupported,
} from "firebase/messaging";
import { Call } from "./fetch";

const firebaseConfig = {
    apiKey: "AIzaSyCA7-sbgR9IUZOqNchSTJWRPZ74KlW_dOE",
    authDomain: "intranet-ucg.firebaseapp.com",
    projectId: "intranet-ucg",
    storageBucket: "intranet-ucg.appspot.com",
    messagingSenderId: "904637427607",
    appId: "1:904637427607:web:eda397d289aae0f5f25ed2",
    measurementId: "G-FT5QJE47X8",
};

const startFirebaseApp = async (callbackNotification) => {
    const isSupportedBrowser = await isSupported();

    // console.log("¿Navegador soportado?", isSupportedBrowser);

    if (!isSupportedBrowser) {
        console.warn("Firebase no disponible: Navegador no soportado");
        return;
    }

    const app = initializeApp(firebaseConfig);
    const messaging = getMessaging(app);

    try {
        const token = await getToken(messaging, {
            vapidKey:
                "BFlCcr9v41TLXaXxsF5DcWEjNRUcGagFeeDBToW9NSrd3H4I6_khzPEtMRxM0q0hYguO98JUPxBbrkpcWAv_OvQ",
        });
        if (token) {
            // console.log("Token de FCM:", token);
            try {
                await Call(`users/notify/add/token`, "PUT", {
                    token,
                });
            } catch (callError) {
                console.error("Error al llamar a la API:", callError);
            }
        } else {
            console.log("No se pudo obtener el token.");
        }
    } catch (e) {
        console.error("Error detallado al obtener el token:", e);
        if (e.code === "messaging/permission-blocked") {
            console.warn("Permiso de notificaciones bloqueado por el usuario.");
        }
    }

    onMessage(messaging, (payload) => {
        // console.log("Mensaje recibido:", payload);
        callbackNotification(payload);
    });
};

export { startFirebaseApp };
